import { formatName } from "@api";
import type { IRecipient } from "@complex/SendMailModal/type";
import { FloatingElement } from "@data-display/layout/FloatingElement";
import CloseIcon from "@mui/icons-material/Close";
import { Divider, IconButton, Stack, Typography } from "@mui/material";

interface IRecipientRowProps {
  recipient: IRecipient;
  removeRecipient: () => void;
}

export const RecipientRow = ({ recipient, removeRecipient }: IRecipientRowProps) => {
  return (
    <Stack pt="4px">
      <Stack direction="row" justifyContent="space-between">
        <Typography color={recipient.invalidAddress ? "secondary" : "black"}>
          <Typography variant="body1SemiBold">{formatName(recipient.candidate)} :</Typography>{" "}
          {recipient.candidate.address.formatted || "-"}
        </Typography>
        <FloatingElement position="right">
          <IconButton size="small" onClick={() => removeRecipient()}>
            <CloseIcon fontSize="small" color="primary" />
          </IconButton>
        </FloatingElement>
      </Stack>
      <Divider sx={{ borderWidth: "1px", marginTop: "4px" }} />
    </Stack>
  );
};
